import type { ReactNode } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

// The app's confirmation sheets and alerts ("Скасувати зміни?", "Вимкнути сайт?", "Замінити
// чернетку?", "Відключити Claude?") as the admin's dialog.
export function SiteConfirmDialog({
  open,
  title,
  message,
  children,
  confirmLabel,
  cancelLabel,
  destructive = false,
  busy = false,
  onConfirm,
  onCancel,
  testId,
}: {
  open: boolean;
  title: string;
  message: string;
  children?: ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  destructive?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  testId: string;
}) {
  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      data-testid={testId}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <SoftTypography variant="button" color="text" fontWeight="regular">
          {message}
        </SoftTypography>
        {children}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <SoftButton
          variant="outlined"
          color="secondary"
          disabled={busy}
          onClick={onCancel}
          data-testid={`${testId}-cancel`}
        >
          {cancelLabel}
        </SoftButton>
        <SoftButton
          variant="gradient"
          color={destructive ? "error" : "info"}
          disabled={busy}
          onClick={onConfirm}
          data-testid={`${testId}-confirm`}
        >
          {busy ? <CircularProgress size={16} color="inherit" /> : confirmLabel}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}
